import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const moduleMenuItemsTemplate  = (handleEdit, handleDelete) => {

    return  [
        { id: 'edit', icon: EditIcon, text: 'Edit Module', color: 'green', handler: handleEdit },
        { id: 'delete', icon: DeleteIcon, text: 'Delete Module', color: 'red', handler: handleDelete }
    ];
}

